// @ts-check
import { useQuery } from 'apollo-3';
// import delve from 'dlv'; // deprecated: only used by removed getDownloadlink
import log from 'loglevel';
import queryString from 'query-string';
import React, { useEffect, useRef, useState } from 'react';
import { compose, graphql } from 'react-apollo';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { AccessContentModal, MESSAGE_TYPE } from 'Components/AccessContentModal';
import { Box, Flex, Image } from 'Components/Base';
import { TIME_UP_LOCKED_TYPES, VIDEO_SOURCE_TYPE } from 'Components/Classroom/Content/constant';
import Loading from 'Components/Loading';
import { useConfig } from 'Context/ConfigContext';
import { useClassroomCourseData, useClassroomTimeData } from 'Domain/Classroom';
import { useMyCourseData } from 'Domain/MyCourseData';
import { useClassroomTracking } from 'Util/Analytics';
import { withCapacitor } from 'Util/Capacitors/hoc';
import useDisclosure from 'Util/Hooks/useDisclosure';
import useGoToTungKaiLearningPage from 'Util/Hooks/useGoToTungKaiLearningPage';
import useMyExternalProfile from 'Routes/Classroom/Domain/useMyExternalProfile';

import { useClassroomContext } from '../../Context/ClassroomContext';
import {
  earnUserPoint,
  generateAssetSignedUrlsByAssetId,
  // generateClassroomAssetSignedUrl, // deprecated: use generateClassroomCourseAssetSignedUrls (by assetId)
  // generateClassroomAssetSignedUrls, // deprecated: use generateClassroomCourseAssetSignedUrls (by assetId)
  generateClassroomLiveSignedUrl,
  generateClassroomVideoSignedUrl,
  generateClassroomVideoSignedUrlBySourceType,
  updateClassroomCurrentSubSection,
  updateClassroomQuizSimpleResult,
  updateClassroomSubSectionVideoProgress,
  updateClassroomSubsectionStatus,
  updateClassroomTimeCompleteCourseItem,
} from '../../GraphQL/mutation/Classroom.mutation';
import { classroomSubSectionContent } from '../../GraphQL/query/Classroom.query';
import { myCourse } from '../../GraphQL/query/Product.query';
import getConfig from '../../Util/Config';
import fetch2, { METHOD } from '../../Util/fetch';

const { localCaching } = getConfig();
const { isEnabled: isEnabledLocalCaching, path: localCachingPath } = localCaching;

export const CONTENT_DATA = {
  VIDEOTIME: 'VIDEOTIME',
};

// How long the time's up modal stays up before leaving on its own
const TIME_UP_AUTO_LEAVE_MS = 5000;
// How long to wait for the TungKai handoff before exiting the normal way
const TUNGKAI_REDIRECT_TIMEOUT_MS = 5000;

const ImageWrapper = styled(Box)`
  margin: 0 auto;
  max-width: 80vw;
  @media (min-width: 768px) {
    max-width: 30vw;
  }
  @media (max-width: 768px) and (orientation: landscape) {
    display: none;
  }
`;

const ClassroomSubsection = ({
  children,
  capacitorContext,
  // onGetAssetUrl, // deprecated: generateClassroomAssetSignedUrl HOC removed
  // getAssetUrls, // deprecated: generateClassroomAssetSignedUrls HOC removed
  getAssetUrlsByAssetId,
  getVideoUrl,
  getVideoUrlBySourceType,
  getLiveVideoUrl,
  updateClassroomSubSectionVideoProgress,
  updateClassroomSubsectionStatus,
  updateClassroomTimeCompleteCourseItem,
  updateClassroomQuizSimpleResult,
  earnUserPoint,
  errorChecker,
}) => {
  const {
    currentSubsectionId,
    currentSubsectionReferId,
    classroomCourseId,
    classroomTimeId,
    courseId,
    hasClassroomSession,
    isConcurrent,
    isEnableVideoResume,
    refreshCourseData,
    updateIsConcurrent,
    updateUserProfileData,
    userProfileData,
    courseData,
    currentLearningMode,
    handleSetUnauthorizedUser,
    subsectionIdSourceMissionIdMapper,
  } = useClassroomContext();
  // [LAMS-2441] Resolve the BU (login provider) next to userId so it rides down as a prop. cache-only = no refetch.
  const { data: myExternalProfileData } = useMyExternalProfile({ fetchPolicy: 'cache-only' });
  const userProvider = myExternalProfileData?.myExternalProfile?.providerName ?? '';
  const {
    logSubsectionVideoTypeComplete,
    logSubsectionVideoTypeCompleteClient,
    logSubsectionVideoTypeCompleteError,
  } = useClassroomTracking();
  const { isClassroomTrialMode } = useClassroomCourseData();
  const { handleGetClassroomTime, handleUpdateClassroomTime } = useClassroomTimeData({
    classroomTimeId,
  });
  const [isOpenRemainTimeUpModal, openRemainTimeUpModal, closeRemainTimeUpModal] = useDisclosure();
  const [isOpenUnReleaseContentModal, openUnReleaseContentModal, closeUnReleaseContentModal] =
    useDisclosure();
  const [unAuthFailedCounter, setUnAuthFailedCounter] = useState(0);
  const { data: myCourseData } = useMyCourseData();

  const history = useHistory();
  const {
    landingRoute = '/my-courses',
    uiVariant,
    classroom: { defaultOwnerLogoUrl, disableMarkCompletedOnTrialCourse },
  } = useConfig();

  const reviewRef = useRef({ isComplete: false, isEnteringSubsection: true });
  const backdropRef = useRef(false);
  const currentLearningModeRef = useRef(currentLearningMode);
  const lastVideoProgressSentRef = useRef(null);

  useEffect(() => {
    // workaround: สำหรับ LearnCraftVideoBox เพราะ LearnCraftVideoBox หลีกเลี่ยงการ trigger useEffect เพราะส่งผลกับการนับ watchDuration
    // ทำให้ onCompleted (updateOnClassroomComplete) ไม่อัพเตดตาม จึงใช้ useRef แทน
    currentLearningModeRef.current = currentLearningMode;
  }, [currentLearningMode]);

  // deprecated: generateClassroomAssetSignedUrl mutation closed; use getDownloadlinkByAssetId
  // const getDownloadlink = async (fileKey) => {
  //   const { data } = await onGetAssetUrl({
  //     variables: { subSectionId: currentSubsectionId, bucketType: 'course', fileKey },
  //   });
  //   const downloadLink = delve(data, ['generateClassroomAssetSignedUrl', 'url'], '#');
  //   return downloadLink;
  // };

  const getDownloadlinkByAssetId = async (fileKey, assetId) => {
    const { data } = await getAssetUrlsByAssetId({
      variables: { classroomId: classroomCourseId, sourceCourseAssetId: assetId },
    });
    const downloadLink = data?.generateClassroomCourseAssetSignedUrls?.urls?.[0]?.signedUrl ?? '#';
    return downloadLink;
  };

  useEffect(() => {
    if (!isClassroomTrialMode) {
      reviewRef.current.isComplete = false;
      reviewRef.current.isEnteringSubsection = true;
    }
    backdropRef.current = false;
  }, [currentSubsectionId]);

  useEffect(() => {
    if (classroomTimeId) {
      handleGetClassroomTime({ classroomTimeId }, openRemainTimeUpModal);
    }
  }, [classroomTimeId]);

  const location = useLocation();
  const queryParam = queryString.parse(location.search);

  const { data, loading, error, refetch } = useQuery(classroomSubSectionContent, {
    variables: {
      classroomCourseId,
      subSectionId: currentSubsectionId,
      subSectionReferId: currentSubsectionReferId,
    },
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
    onError: (error) => {
      const errors = error?.graphQLErrors ?? [];
      const contentUnReached = errors.find(({ message, extensions }) =>
        // ANY-3349: gateway strips extensions.response; message is the fallback
        [extensions?.response?.body?.error?.message, message].some((text) =>
          text?.includes('Permission denied: the content is not released')
        )
      );
      if (contentUnReached && errorChecker) {
        backdropRef.current = true;
        openUnReleaseContentModal();
      }
    },
  });

  useEffect(() => {
    if (currentSubsectionId && classroomCourseId) {
      refetch();
    }
  }, [currentLearningMode]);

  const {
    classroomSubSectionContent: contentData,
    classroomSubSectionStatus,
    myProfile,
  } = data || {};
  const { assets, title, description, contentType, isComingSoon } = contentData || {};
  const { materials = [], contentAssets = [] } = assets || {};

  const goToTungKaiLearningPage = useGoToTungKaiLearningPage();
  const isRedirectingRef = useRef(false);

  const handleExitClassroom = () => {
    // For a B2B student need to navigate back to Storefront
    if (queryParam.from) {
      const fromURL = decodeURIComponent(queryParam.from);
      window.location = fromURL;
    } else {
      history.push(landingRoute);
    }
  };

  const leaveTimeLockedContent = async () => {
    // Ignore taps while the TungKai handoff is still running
    if (isRedirectingRef.current) return;
    isRedirectingRef.current = true;
    let hasExited = false;
    const exitClassroom = () => {
      if (hasExited) return;
      hasExited = true;
      isRedirectingRef.current = false;
      closeRemainTimeUpModal();
      handleExitClassroom();
    };
    // A TungKai course goes back to its learning page, where exercises still work.
    // Keep the modal open until then, so a failed redirect never shows the content again.
    // The token request has no timeout and openInApp resolves as soon as it sets the URL,
    // so if the page is still here after the timeout, exit normally instead of staying locked.
    const fallbackTimer = setTimeout(exitClassroom, TUNGKAI_REDIRECT_TIMEOUT_MS);
    if (await goToTungKaiLearningPage()) return;
    clearTimeout(fallbackTimer);
    exitClassroom();
  };

  const isTimeLockedContent = TIME_UP_LOCKED_TYPES.includes(contentType);
  const isShowingTimeUpModal = isOpenRemainTimeUpModal && errorChecker && isTimeLockedContent;

  // Leave on its own so the learner never has to rely on the button
  useEffect(() => {
    if (!isShowingTimeUpModal) return;
    const autoLeaveTimer = setTimeout(leaveTimeLockedContent, TIME_UP_AUTO_LEAVE_MS);
    return () => clearTimeout(autoLeaveTimer);
  }, [isShowingTimeUpModal]);

  if (!hasClassroomSession) return children({});
  if (loading) return <Loading width={100} height={100} />;

  if (isShowingTimeUpModal) {
    return (
      <AccessContentModal
        messageType={MESSAGE_TYPE.COURSE_REMAINING_TIMEOUT}
        muiProps={{
          isActive: isOpenRemainTimeUpModal,
        }}
        onClick={leaveTimeLockedContent}
      />
    );
  }

  if (isConcurrent && errorChecker) {
    return (
      <AccessContentModal
        muiProps={{
          isActive: true,
        }}
        messageType={MESSAGE_TYPE.CONCURRENT_USER}
        onClick={handleExitClassroom}
      />
    );
  }

  if (isOpenUnReleaseContentModal && errorChecker) {
    return (
      <AccessContentModal
        messageType={MESSAGE_TYPE.CONTENT_UNAVAILABLE}
        muiProps={{ isActive: true }}
        onClick={closeUnReleaseContentModal}
      />
    );
  }

  const resolveVideoSourceType = async () => {
    if (isEnabledLocalCaching) {
      try {
        const localCachingData = await fetch2(
          localCachingPath,
          null,
          METHOD.GET,
          null,
          {
            parseJson: true,
            includeCredentials: false,
            includeContentType: false,
          },
          {},
          500
        );
        if (localCachingData) {
          return VIDEO_SOURCE_TYPE.LOCAL;
        }
      } catch (error) {
        log.error(error);
      }
    }
    return VIDEO_SOURCE_TYPE.ONLINE;
  };

  const generateVideoSignedUrl = async (videoId, provider, duration) => {
    if (!isConcurrent) {
      const videoSourceType = await resolveVideoSourceType();

      const timeToLive = duration < 60 ? 180 : 3 * duration;
      const { data } = await getVideoUrl({
        variables: {
          classroomCourseId,
          subSectionId: currentSubsectionId,
          videoId,
          provider,
          timeToLive,
          includeVideoAccessToken: true,
        },
        fetchPolicy: 'no-cache',
      });
      if (data.generateClassroomVideoSignedUrl.code === '200') {
        const { url: signedUrl, videoAccessToken } = data.generateClassroomVideoSignedUrl || {};
        if (isEnabledLocalCaching) {
          try {
            const { data } = await getVideoUrlBySourceType({
              variables: {
                videoSigningOptions: { videoKey: videoId, timeToLive },
                videoSourceType,
              },
              fetchPolicy: 'no-cache',
            });
            if (data.vdmGenerateVideoSignedUrl.code === 200) {
              const { signedUrl } = data.vdmGenerateVideoSignedUrl;
              return { signedUrl, videoAccessToken };
            }
          } catch (error) {
            log.error(error);
          }
        }
        return { signedUrl, videoAccessToken };
      } else if (['403', 'FORBIDDEN'].includes(data.generateClassroomVideoSignedUrl.code)) {
        updateIsConcurrent(true);
      }
    }
    return videoId;
  };

  const generateLiveSignedUrl = async (channelName) => {
    // TODO have to change to config in subsection
    const timeToLive = 7200;
    const { data } = await getLiveVideoUrl({
      variables: {
        liveSigningOptions: { channelName, timeToLive },
      },
      fetchPolicy: 'no-cache',
    });
    if (data.vdmGenerateLiveSignedUrl.code === 200) {
      const { signedUrl } = data.vdmGenerateLiveSignedUrl || {};
      return { signedUrl };
    }
  };

  // deprecated: generateClassroomAssetSignedUrls mutation closed; use generateClassroomAssetSignedUrlsByAssetId
  // const generateClassroomAssetSignedUrls = async (assetList = []) => {
  //   const { data } = await getAssetUrls({
  //     variables: { assetList },
  //     fetchPolicy: 'no-cache',
  //   });
  //   if (data?.generateClassroomAssetSignedUrls?.success) {
  //     const { urls } = data?.generateClassroomAssetSignedUrls || {};
  //     return urls;
  //   }
  // };

  const generateClassroomAssetSignedUrlsByAssetId = async (assetList = [], assetId) => {
    const { data } = await getAssetUrlsByAssetId({
      variables: { classroomId: classroomCourseId, sourceCourseAssetId: assetId },
    });
    const urls = data?.generateClassroomCourseAssetSignedUrls?.urls;
    return urls;
  };

  const isSubsectionCompleted = () => {
    const learningMode = currentLearningModeRef.current;

    if (learningMode === 'DEFAULT' && courseData?.courseLearningModeDetails.length === 1) {
      const completedSubsectionsIds = courseData?.completedSubsectionsIds ?? [];
      return completedSubsectionsIds.includes(currentSubsectionReferId);
    } else {
      const learningModeCompletedSubsectionIds =
        courseData?.learningModeCompletedSubsectionIds ?? [];
      const currentLearningModeCompleted =
        learningModeCompletedSubsectionIds[currentSubsectionReferId];
      return currentLearningModeCompleted
        ? currentLearningModeCompleted.includes(learningMode)
        : false;
    }
  };

  const updateClassroomTime = (timeSpending) => {
    if (classroomTimeId) {
      log.debug(
        'updateClassroomTime',
        classroomTimeId,
        currentSubsectionReferId,
        classroomCourseId,
        courseId
      );
      const learningMode = currentLearningModeRef.current;
      let isCompleted = isSubsectionCompleted();
      const subject = myCourseData?.courseInfo?.courseLevel;
      const mode = courseData?.courseMode;
      const courseRevisionId = courseData?.courseRevision.toString();
      const isBonusContent =
        Array.isArray(contentAssets) && contentAssets.length > 0
          ? contentAssets[0]?.content?.isBonusContent || false
          : false;

      handleUpdateClassroomTime(
        {
          classroomTimeId,
          classroomId: classroomCourseId,
          courseId,
          subSectionReferId: currentSubsectionReferId,
          timeSpending,
          learningMode,
          subsectionRevisionId: currentSubsectionId,
          isCompleted,
          subject,
          isBonusContent,
          mode,
          courseRevisionId,
        },
        openRemainTimeUpModal
      );
    }
  };

  const updateClassroomTimeComplete = () => {
    if (classroomTimeId) {
      log.debug('updateClassroomTimeComplete', classroomTimeId);
      updateClassroomTimeCompleteCourseItem({
        variables: {
          classroomTimeId,
        },
      });
    }
  };

  const updateSubSectionData = ({ dataType, value }) => {
    if (dataType !== CONTENT_DATA.VIDEOTIME) return;
    if (!isEnableVideoResume) return;

    if (!Number.isInteger(value) || value < 0) {
      log.warn('updateVideoProgress: dropped non-integer videoTime', value);
      return;
    }

    const sentKey = `${currentSubsectionReferId}:${value}`;
    if (lastVideoProgressSentRef.current === sentKey) return;
    lastVideoProgressSentRef.current = sentKey;

    // Only the request that still owns the ref may clear it
    const releaseSentKey = () => {
      if (lastVideoProgressSentRef.current === sentKey) {
        lastVideoProgressSentRef.current = null;
      }
    };

    log.debug('updateVideoProgress', classroomCourseId, currentSubsectionReferId, value);
    updateClassroomSubSectionVideoProgress({
      variables: {
        classroomId: classroomCourseId,
        subSectionReferId: currentSubsectionReferId,
        videoTime: value,
      },
    })
      .then(
        ({ data }) => {
          const { code, success, message } = data?.updateClassroomSubSectionVideoProgress ?? {};
          if (success) return;

          // Let the next sample retry rather than staying deduped against a value
          releaseSentKey();

          if (['401', '403', 'UNAUTHORIZED', 'UNAUTHENTICATED', 'FORBIDDEN'].includes(code)) {
            setUnAuthFailedCounter((prev) => prev + 1);
            // if unauth failed 3 times, set unauth user (3 is a magic number)
            if (unAuthFailedCounter === 3) {
              handleSetUnauthorizedUser(true);
              setUnAuthFailedCounter(0);
            }
            return;
          }

          log.error(
            `Error updateClassroomSubSectionVideoProgress: { code: ${code}, message: ${message}, subSectionReferId: ${currentSubsectionReferId}, videoTime: ${value} }`
          );
        },
        (error) => {
          releaseSentKey();
          log.error('updateVideoProgress: request failed', error);
        }
      )
      .catch((error) => {
        log.error('updateVideoProgress: failed handling response', error);
      });
  };

  /** @param { string | null } learningMode */
  /** @param { number | null } videoWatchedDuration */
  /** @param { number | null } videoCompletionThreshold */
  /** @param { number | null } videoTotalDuration */
  /** @param { string | null } videoProvider */
  const updateSubsectionStatus = (
    learningMode,
    videoWatchedDuration,
    videoCompletionThreshold,
    videoTotalDuration,
    videoProvider
  ) => {
    const status = 'COMPLETE';
    const sourceType = courseData?.courseSourceType || 'COURSE'; // NOTE: Fallback to `COURSE` (Old backoffice course) if courseSourceType is null
    log.debug('updateClassroomStatus', classroomCourseId, currentSubsectionReferId, status);
    if (contentType === 'VIDEO' || contentType === 'VIDEO_SLIDE') {
      logSubsectionVideoTypeCompleteClient({
        videoWatchedDuration,
        videoCompletionThreshold,
        videoTotalDuration,
        videoProvider,
        subsectionTitle: title,
        subsectionContentType: contentType,
      });
    }
    updateClassroomSubsectionStatus({
      variables: {
        classroomId: classroomCourseId,
        subSectionReferId: currentSubsectionReferId,
        status,
        learningMode: learningMode,
        sourceType,
      },
      //FIXME: support feedback popup on progress reached
      refetchQueries: [{ query: myCourse, variables: { courseId } }],
    })
      .then(({ data }) => {
        refreshCourseData();

        if (contentType === 'VIDEO' || contentType === 'VIDEO_SLIDE') {
          const subSectionStatus = data?.updateSubSectionStatus?.subSectionStatus?.subSectionStatus;

          if (!subSectionStatus) {
            throw new Error('[ClassroomSubsectionStatus] Missing subSectionStatus from server');
          }

          const currentSubsection = subSectionStatus.find(
            (item) => item.courseItemReferId === currentSubsectionReferId
          );

          logSubsectionVideoTypeComplete({
            videoWatchedDuration,
            videoCompletionThreshold,
            videoTotalDuration,
            videoProvider,
            subsectionTitle: title,
            subsectionContentType: contentType,
            serverTimestamp: currentSubsection?.createdAt,
          });
        }

        const sourceMissionId = subsectionIdSourceMissionIdMapper?.get(currentSubsectionId ?? '');
        if (sourceMissionId && courseId && classroomCourseId) {
          earnUserPoint({
            variables: {
              sourceCourseId: courseId,
              courseItemId: sourceMissionId,
              classroomId: classroomCourseId,
            },
          }).catch((error) => {
            log.error('[EarnUserPoint] Failed to earn user point %o', error);
          });
        }
      })
      .catch((error) => {
        if (contentType === 'VIDEO' || contentType === 'VIDEO_SLIDE') {
          logSubsectionVideoTypeCompleteError({
            videoWatchedDuration,
            videoCompletionThreshold,
            videoTotalDuration,
            videoProvider,
            subsectionTitle: title,
            subsectionContentType: contentType,
            errorMessage: error.message,
          });
        }
        log.error('[ClassroomSubsectionStatus] Failed to update', error);
      });
  };

  const updateOnClassroomComplete = (
    videoWatchedDuration,
    videoCompletionThreshold,
    videoTotalDuration,
    videoProvider
  ) => {
    if (disableMarkCompletedOnTrialCourse && isClassroomTrialMode) return;

    reviewRef.current.isComplete = true;
    reviewRef.current.isEnteringSubsection = false;
    updateSubsectionStatus(
      currentLearningModeRef.current,
      videoWatchedDuration,
      videoCompletionThreshold,
      videoTotalDuration,
      videoProvider
    );
    updateClassroomTimeComplete();
  };

  const updateQuizSimpleResult = (variables) => {
    updateClassroomQuizSimpleResult({ variables: variables }).then(({ data }) => {
      const { updateClassroomQuizSimpleResult } = data;
      const { code, success, message } = updateClassroomQuizSimpleResult;
      if (!success) {
        console.error(
          `Error updateClassroomQuizSimpleResult: { code: ${code}, message: ${message} }`
        );
      }
    });
  };

  const {
    displayName,
    id: userId,
    phoneNumber,
  } = userProfileData ? userProfileData : myProfile || {};
  //If the components that used ClassroomProvider don't set userProfileData in prop, we will set it in this step
  if (!userProfileData) updateUserProfileData({ displayName, userId });

  return (
    <>
      {children({
        getDownloadlink: getDownloadlinkByAssetId,
        materials,
        contentAssets,
        shouldShowReview:
          !isClassroomTrialMode &&
          reviewRef.current.isComplete &&
          !reviewRef.current.isEnteringSubsection,
        isEnableVideoResume,
        error,
        userDisplayName: displayName,
        userPhoneNumber: phoneNumber,
        title,
        description,
        contentType,
        classroomSubSectionStatus,
        generateVideoSignedUrl,
        generateLiveSignedUrl,
        generateClassroomAssetSignedUrls: generateClassroomAssetSignedUrlsByAssetId,
        updateSubSectionData,
        updateClassroomTime,
        updateOnClassroomComplete,
        updateQuizSimpleResult,
        CONTENT_DATA,
        classroomCourseId,
        currentSubsectionId,
        currentSubsectionReferId,
        classroomTimeId,
        courseId,
        courseRevision: courseData?.courseRevision,
        // Carry the BU alongside userId for downstream speed resolution.
        userProfileData: userProfileData ? { ...userProfileData, userProvider } : userProfileData,
        isComingSoon,
      })}
      {backdropRef.current && (
        <Flex
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          bg={'white'}
          height={uiVariant !== 'PAAS' ? '100vh' : '90%'}
          py={5}
          px={3}
        >
          <ImageWrapper>
            <Image src={defaultOwnerLogoUrl ?? '/assets/images/not_found.png'} />
          </ImageWrapper>
        </Flex>
      )}
    </>
  );
};

export default compose(
  withCapacitor,
  graphql(generateAssetSignedUrlsByAssetId, {
    name: 'getAssetUrlsByAssetId',
  }),
  // deprecated: generateClassroomAssetSignedUrl mutation closed
  // graphql(generateClassroomAssetSignedUrl, {
  //   name: 'onGetAssetUrl',
  // }),
  graphql(generateClassroomVideoSignedUrl, {
    name: 'getVideoUrl',
  }),
  // deprecated: generateClassroomAssetSignedUrls mutation closed
  // graphql(generateClassroomAssetSignedUrls, {
  //   name: 'getAssetUrls',
  // }),
  graphql(generateClassroomVideoSignedUrlBySourceType, {
    name: 'getVideoUrlBySourceType',
  }),
  graphql(generateClassroomLiveSignedUrl, {
    name: 'getLiveVideoUrl',
  }),
  graphql(updateClassroomCurrentSubSection, {
    name: 'updateClassroomCurrentSubSection',
  }),
  graphql(updateClassroomSubsectionStatus, {
    name: 'updateClassroomSubsectionStatus',
  }),
  graphql(updateClassroomSubSectionVideoProgress, {
    name: 'updateClassroomSubSectionVideoProgress',
  }),
  graphql(updateClassroomTimeCompleteCourseItem, {
    name: 'updateClassroomTimeCompleteCourseItem',
  }),
  graphql(updateClassroomQuizSimpleResult, {
    name: 'updateClassroomQuizSimpleResult',
  }),
  graphql(earnUserPoint, {
    name: 'earnUserPoint',
  })
)(ClassroomSubsection);

/** generate graphql type by https://the-guild.dev/graphql/codegen with plugin `jsdoc`
 * @typedef {Object} ClassroomCourseSubSectionContent
 * @property {string} id
 * @property {string} title
 * @property {string} referId
 * @property {string} [description]
 * @property {CLASSROOM_SUBSECTION_TYPE} contentType
 * @property {ClassroomTOCSubSectionMeta} meta
 * @property {ClassroomCourseAssets} assets
 * @property {boolean} isComingSoon
 * @property {boolean} canPreview
 * @property {DateTime} [releasedAt]
 * @property {boolean} isLock
 * @property {boolean} isPrerequisite
 * @property {Array<COURSE_LEARNING_MODE>} [learningModes]
 */

/**
 * @typedef {*} DateTime
 */

/**
 * @typedef {("ARTICLE"|"ASSIGNMENT"|"LIVECODING"|"VIDEO"|"LIVE_VIDEO"|"VIDEO_SLIDE"|"QUIZ"|"QUIZ_SIMPLE"|"NOTEBOARD"|"FULL_LESSON"|"SUMMARY_LESSON"|"EBOOK")} CLASSROOM_SUBSECTION_TYPE
 */

/**
 * @typedef {("SLIDES"|"VIDEO"|"LIVE_VIDEO"|"EXTERNAL"|"YOUTUBE"|"ARTICLE"|"ASSIGNMENT"|"QUIZ"|"QUIZ_SIMPLE"|"LIVECODING"|"NOTEBOARD"|"PDF"|"OTHER")} MATERIAL_TYPE
 */

/**
 * @typedef {Object} SubContentVideoMaterial
 * @property {string} provider
 * @property {string} videoId
 * @property {string} [url]
 * @property {string} [thumbnailUrl]
 * @property {number} [duration]
 * @property {COURSE_LEARNING_MODE} learningMode
 */

/**
 * @typedef {Object} VideoMaterial
 * @property {string} provider
 * @property {string} videoId
 * @property {string} [url]
 * @property {string} [thumbnailUrl]
 * @property {number} [duration]
 * @property {Array<SubContentVideoMaterial>} subContents
 */

/**
 * @typedef {Object} SubContentQuizMaterial
 * @property {string} examId
 * @property {number} [maxAttempts]
 * @property {number} [timeLimit]
 * @property {number} [passingScore]
 * @property {*} [passingCriteria]
 * @property {number} [fullScore]
 * @property {Array<(string|null|undefined)>} [tags]
 * @property {Array<(*)>} [rawTags]
 * @property {*} [resultOptions]
 * @property {COURSE_LEARNING_MODE} learningMode
 */

/**
 * @typedef {Object} QuizMaterial
 * @property {string} examId
 * @property {number} [maxAttempts]
 * @property {number} [timeLimit]
 * @property {number} [passingScore]
 * @property {*} [passingCriteria]
 * @property {number} [fullScore]
 * @property {Array<(string|null|undefined)>} [tags]
 * @property {Array<(*)>} [rawTags]
 * @property {*} [resultOptions]
 * @property {Array<SubContentQuizMaterial>} subContents
 */

/**
 * @typedef {Object} ArticleMaterial
 * @property {string} htmlContent
 */

/**
 * @typedef {(VideoMaterial|QuizMaterial|ArticleMaterial|*)} MaterialContent
 */

/**
 * @typedef {Object} ClassroomTOCSubSectionMeta
 * @property {number} [videoTime]
 */

/**
 * @typedef {Object} ClassroomCourseAssets
 * @property {Array<(ClassroomCourseMaterial|null|undefined)>} [contentAssets]
 * @property {Array<(ClassroomCourseMaterial|null|undefined)>} [materials]
 */

/**
 * @typedef {Object} ClassroomCourseMaterial
 * @property {string} id
 * @property {string} referId
 * @property {string} [title]
 * @property {string} [description]
 * @property {MATERIAL_TYPE} [type]
 * @property {MaterialContent} [content]
 */

/**
 * @typedef {("FOCUS")} COURSE_LEARNING_MODE
 */
